module.exports = __webpack_public_path__ + "img/11.338b0d31.png";